export {
    EllipsisTextHint,
    EllipsisTextHint as default,
} from './ellipsis-text-hint';
